import { createAction } from 'redux-actions'

export const setAvailableColumns = createAction('SET_AVAILABLE_REPORT_TEMPLATE_COLUMNS')
export const setSelectedColumns = createAction('SET_SELECTED_REPORT_TEMPLATE_COLUMNS')

export const resetState = createAction('RESET_REPORT_TEMPLATE')
